module.exports = __webpack_public_path__ + "build/desktop/a/img/icon_point_active.c8f0eba76b60f2b5e88dbd7413289127.svg";